/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * URL Normalization for Instagram Redirects
 * Fixes case-sensitivity issues with collection URLs from Instagram redirects
 * This ensures that URLs like /collections/StoreName redirect to /collections/storename
 */
(function() {
  if (typeof window !== 'undefined' && window.location) {
    var currentPath = window.location.pathname;
    var collectionsMatch = currentPath.match(/^(\/collections\/)([^\/]+)(.*)$/i);
    
    if (collectionsMatch) {
      var prefix = collectionsMatch[1];
      var collectionName = collectionsMatch[2];
      var suffix = collectionsMatch[3];
      
      if (collectionName !== collectionName.toLowerCase()) {
        var normalizedPath = prefix + collectionName.toLowerCase() + suffix;
        
        var newUrl = normalizedPath + window.location.search + window.location.hash;
        
        if (newUrl !== currentPath + window.location.search + window.location.hash) {
          window.location.replace(newUrl);
          return;
        }
      }
    }
  }
})();

/**
 * Fix variant image switching - ensures variant.image is mapped to featured_media
 * Shopify variants use 'image' property, but the theme expects 'featured_media'
 * 
 * Strategy:
 * 1. Process JSON in DOM before ProductVariants parses it (primary)
 * 2. Intercept variant:changed event as backup (secondary)
 */
(function () {
  'use strict';

  // Function to add featured_media to a variant if it has an image
  function addFeaturedMediaToVariant(variant) {
    if (variant && variant.image && variant.image.id && !variant.featured_media) {
      variant.featured_media = {
        id: variant.image.id,
        media_type: 'image'
      };
      return true;
    }
    return false;
  }

  // Process product JSON in DOM before ProductVariants parses it
  function processProductJSON() {
    var jsonElements = document.querySelectorAll('[data-product-json]');

    jsonElements.forEach(function (jsonElement) {
      // Skip if already processed
      if (jsonElement.dataset.variantFixProcessed) {
        return;
      }

      try {
        var productData = JSON.parse(jsonElement.textContent);

        if (productData.product && productData.product.variants) {
          var modified = false;

          // Process all variants
          productData.product.variants.forEach(function (variant) {
            if (addFeaturedMediaToVariant(variant)) {
              modified = true;
            }
          });

          // Update JSON in DOM if modified
          if (modified) {
            jsonElement.textContent = JSON.stringify(productData);
            jsonElement.dataset.variantFixProcessed = 'true';
          }
        }
      } catch (e) {
        // Silently ignore parsing errors
      }
    });
  }

  // Run immediately (before DOMContentLoaded)
  if (document.readyState === 'loading') {
    // Use a script that runs immediately
    processProductJSON();

    // Also run on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', processProductJSON);
  } else {
    processProductJSON();
  }

  // Use MutationObserver to catch dynamically added product JSON
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      processProductJSON();
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
  }

  // CRITICAL: Intercept variant:changed event
  // The variant object in event.detail is a reference to the one in ProductVariants' productData
  // Modifying it here will affect what variantHasChanged receives
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;

    if (!variant) {
      return;
    }

    // Find the product section and get product data to map image ID to media ID
    var productSection = event.target.closest('[data-section-type="product"]');
    if (!productSection) {
      // Try finding by traversing up
      var element = event.target;
      while (element && element !== document.body) {
        if (element.hasAttribute && element.hasAttribute('data-section-type')) {
          productSection = element;
          break;
        }
        element = element.parentElement;
      }
    }

    if (productSection) {
      var productJson = productSection.querySelector('[data-product-json]');
      if (productJson) {
        try {
          var productData = JSON.parse(productJson.textContent);

          // Get the image ID from variant (could be image.id or featured_image.id)
          var imageId = null;
          if (variant.image && variant.image.id) {
            imageId = variant.image.id;
          } else if (variant.featured_image && variant.featured_image.id) {
            imageId = variant.featured_image.id;
          }

          // Find the media object that matches this image ID
          var matchingMedia = null;
          if (productData.product && productData.product.media && imageId) {
            matchingMedia = productData.product.media.find(function (media) {
              // Media can have a preview_image with an id that matches the image ID
              if (media.preview_image && media.preview_image.id == imageId) {
                return true;
              }
              // Or the media itself might have the image ID
              if (media.id == imageId) {
                return true;
              }
              // Or check if media is associated with this variant
              if (media.variants && media.variants.length > 0) {
                return media.variants.some(function (v) {
                  return v.id === variant.id;
                });
              }
              return false;
            });
          }

          if (matchingMedia) {
            variant.featured_media = {
              id: matchingMedia.id,
              media_type: matchingMedia.media_type || 'image'
            };
          }

          // After setting featured_media, manually trigger gallery update if needed
          // This ensures the gallery updates even if variantHasChanged doesn't work correctly
          if (variant.featured_media && variant.featured_media.id) {
            var mediaId = String(variant.featured_media.id);
            setTimeout(function () {
              var gallery = productSection.querySelector('.product-gallery__carousel');
              if (gallery) {
                var mediaCell = gallery.querySelector('[data-media-id="' + mediaId + '"]');
                if (mediaCell) {
                  // Try to find Flickity instance
                  var flickityInstance = null;
                  var flickityGUID = gallery.flickityGUID;

                  if (flickityGUID) {
                    // Try to find Flickity in global registry
                    for (var prop in window) {
                      try {
                        var obj = window[prop];
                        if (obj && obj.data && obj.data[flickityGUID]) {
                          flickityInstance = obj.data[flickityGUID];
                          break;
                        }
                      } catch (e) { }
                    }
                  }

                  if (flickityInstance && typeof flickityInstance.selectCell === 'function') {
                    try {
                      flickityInstance.selectCell(mediaCell);
                    } catch (e) {
                      // Ignore errors
                    }
                  } else {
                    // Fallback: click the thumbnail
                    var thumbnail = productSection.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
                    if (thumbnail) {
                      thumbnail.click();
                    }
                  }
                }
              }
            }, 100);
          }

          if (imageId) {
            // Fallback: try to find media by checking if any media has this image ID
            // Sometimes the image ID matches the media ID directly
            var mediaById = productData.product.media.find(function (m) {
              return m.id == imageId || (m.preview_image && m.preview_image.id == imageId);
            });

            if (mediaById) {
              variant.featured_media = {
                id: mediaById.id,
                media_type: mediaById.media_type || 'image'
              };
            } else {
              // Last resort: try to find media associated with this variant
              if (variant.featured_media && variant.featured_media.id) {
                var currentMediaId = String(variant.featured_media.id);
                var gallery = productSection.querySelector('.product-gallery__carousel');
                if (gallery) {
                  var mediaCell = gallery.querySelector('[data-media-id="' + currentMediaId + '"]');
                  if (!mediaCell && productData.product.media) {
                    // Try to find media associated with this variant
                    var variantMedia = productData.product.media.find(function (m) {
                      return m.variants && m.variants.some(function (v) {
                        return v.id === variant.id;
                      });
                    });
                    if (variantMedia) {
                      variant.featured_media = {
                        id: variantMedia.id,
                        media_type: variantMedia.media_type || 'image'
                      };
                    }
                  }
                }
              }
            }
          }
        } catch (e) {
          // Silently ignore errors
        }
      }
    }
  }, true); // Capture phase - MUST run before ProductGallery's variantHasChanged listener

})();

window.addEventListener('scroll', () => 
  document.querySelector('#main')
    .classList.toggle('scrolled', window.scrollY > 10)
);

